import { CancelToken } from "axios";
import { actionChannel, take, fork, call, put } from "redux-saga/effects";
import getAxios from "./axiosAPI";
import history from '../history/history';
import { toast } from 'react-toastify';
import * as utils from '../../Utils';
import _ from "lodash";
import { publish } from "./events";

const pendingRequests = {};

const similarPendingRequestExist = (actionType, url) =>
  pendingRequests[actionType] && pendingRequests[actionType].url === url;

function* invokeAPI(action) {
  const { payload } = action;
  const {
    method,
    url,
    data,
    apiConfig,
    action: actionType,
    resolve,
    reject,
    isLoader,
  } = payload;
  try {
    let response = {};

    //console.log('pendingRequests',JSON.stringify(pendingRequests));

    // console.error = function () { }
    // console.warn = function () { }
    //console.log = function() {}

    if (isLoader) {
      //
    }
    const api = getAxios();

    const source = CancelToken.source();
    const cancelToken = source.token;
    pendingRequests[actionType] = { url, api, source };

    // publish('pendingRequests',JSON.stringify(pendingRequests));

    switch (method) {
      case "GET": {
        // if (similarPendingRequestExist(actionType, url)) {
        //   console.log(url);
        //   throw new Error("Similar axios request detected!");
        // } else {

          response = yield call([api, api.get], url, {
            ...apiConfig,
            cancelToken,
          });
        }
        break;
      //}
      case "POST":
        utils.disableBtns();
        response = yield call([api, api.post], url, data, { ...apiConfig });
        break;

      case "PUT":
        utils.disableBtns();
        response = yield call([api, api.put], url, data, { ...apiConfig });
        break;

      case "PATCH":
        utils.disableBtns();
        response = yield call([api, api.patch], url, data, { ...apiConfig });
        break;

      case "DELETE":
        utils.disableBtns();
        response = yield call([api, api.delete], url, { ...apiConfig });
        break;

      case "EMPTY":
        response = { status: 200, data: { status: 200 } }
        break;

      default:
        throw new Error(`API method ${method} is not supported!`);
    }

    if (response.status === Number(200)
      || response.status === Number(201)
      || response.status === Number(201)
    ) {

      yield* dispatchFulfilled(action, response.data);
      utils.enableBtns();

      // yield put(showToastMessage({ message: _get(response, 'data.message', ''), type: _get(response, 'data.type', '') }));
    } else if (response.status === Number(401)) {
      utils.enableBtns();
      // localStorage.clear();
      // toast.error(`Session Timed out! Please login again`);
      // yield call(forwardTo, '/');

      // yield* dispatchRejected(payload.action, action, "Internal server error");
      // yield put(showToastMessage({ message: _get(response, 'data.message', ''), type: _get(response, 'data.type', '') }));
    } else {
      yield* dispatchRejected(payload.action, action, "Internal server error");
      utils.enableBtns();
      //yield put(showToastMessage({ message: 'Session Timed out! Please login again' }));
    }
    delete pendingRequests[actionType];

    //console.log(pendingRequests);
    if (_.isEmpty(pendingRequests)) {
      //
    }
    if (resolve) {
      utils.enableBtns();
      resolve(response.data);
    }
  } catch (error) {
    utils.enableBtns();
    delete pendingRequests[actionType];
    if (_.isEmpty(pendingRequests)) {
      //
    }
    if (error.response && error.response.status === 401) {
      // yield put({ type: `LOGOUT`, payload: error.response });
      // localStorage.clear();
      // window.location.href = "/";
      // return;
    }

    if (error && error.status === 401) {
      // yield put({ type: `LOGOUT`, payload: error.response });
      // localStorage.clear();
      // window.location.href = "/";
      // return;
    }
    yield* dispatchFulfilled(action, { status: 200, data: {} });
    if (reject) {
      reject(error);
    }
  } finally {
    utils.enableBtns();
    // yield put(setStopLoader());
  }
}

function forwardTo(location) {
  history.push(location);
}

function* dispatchFulfilled(action, response) {
  yield put({ type: `${action.payload.action}_SUCCESS`, payload: response });
}

function* dispatchRejected(actionType, action, error) {
  yield put({
    type: `${actionType}_ERROR`,
    actualAction: action,
    payload: { response: error },
  });
}

function* apiSaga() {
  const actionQueue = yield actionChannel("API_INVOCATION");
  while (true) {
    const action = yield take(actionQueue);
    yield fork(invokeAPI, action);
  }
}

export { invokeAPI };
export default apiSaga;
